<template>
    <b-modal id="modal-search-model" size="xl" title="Cari Tipe Barang" no-close-on-esc no-close-on-backdrop>
        <div class="form-content-wrapper mb-3">
            <b-form-group>
                <div class="d-flex small-search">
                    <b-form-input class="mr-2" v-model="searchQuery" ref="searchModel" v-on:keyup.enter="searchModel"
                        name="searchModel" placeholder="No. Model…"></b-form-input>
                    <b-button class="mr-2" variant="pgiBtn" name="anggotaSearchBtn" :disabled="isBusy" @click="searchModel">
                        <i class="fa fa-search"></i>
                    </b-button>
                </div>
            </b-form-group>
        </div>
        <b-table bordered hover show-empty :fields="fields" :busy="isBusy" :items="items" responsive class="mb-3">
            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>
            <template v-slot:empty>
                Tidak ada Data.
            </template>
            <template v-slot:cell(action)="row">
                <div class="no-wrap">
                    <b-button size="sm" variant="pgiBtn" name="pilihAnggotaBtn"
                        @click="selectModel(row.item)">Pilih</b-button>
                </div>
            </template>
        </b-table>

        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="secondary" name="cancelPilihAnggotaBtn" @click="cancel()">
                Batalkan
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'modal-search-model',
    props: {
        merkId: { required: true }
    },
    data() {
        return {

            searchQuery: "",
            searchBy: 1,
            searchByTglLahir: null,
            show: 10,

            fields: [
                { key: "type", label: "Tipe Barang" },
                { key: "modelNumber", label: "No. Model" },
                { key: "action", label: "Aksi" },
            ],
            searchByOption: [
                { id: 1, name: "No. Identitas / KTP" },
                { id: 2, name: "Nama & Tgl Lahir Anggota" },
                { id: 3, name: "No. Anggota" },
                { id: 4, name: "No. Member" }
            ],
            showSearchTanggalLahir: false,
            items: [],
            isBusy: false,
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

        }
    },
    methods: {
        getModel() {
            if (this.searchQuery == "") {
                this.$helper.toastErr(this, "Mohon isi pencarian (minimal 3 karakter)")
            } else {

                this.query = `?merkId=${this.merkId}&modelNumber=${this.searchQuery}`

                this.isBusy = true
                this.$axios.get(`model-number-database/get-types` + this.query).then(response => {
                    this.items = response.data
                })
                    .catch(error => {
                        this.$helper.parseError(this, error)
                    })
                    .finally(() => {
                        this.isBusy = false
                    })
            }
        },

        searchModel() {
            this.getModel()
        },

        onReset() {
            this.searchQuery = ""
            this.items = []
        },

        selectModel(item) {
            item.noModel = item.modelNumber
            item.name = item.type
            this.$emit("model-selected", item)
        },
    },

    watch:{
        'merkId': function (newVal){
            this.searchQuery = ""
            this.items = []
        },
    }
}
</script>